<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M19 3C20.6569 3 22 4.34315 22 6V8C22 9.65685 20.6569 11 19 11H18V13H19C20.6569 13 22 14.3431 22 16V18C22 19.6569 20.6569 21 19 21H5C3.34315 21 2 19.6569 2 18V16C2 14.3431 3.34315 13 5 13H6V11H5C3.34315 11 2 9.65685 2 8V6C2 4.34315 3.34315 3 5 3H19ZM19 15H5C4.44772 15 4 15.4477 4 16V18C4 18.5523 4.44772 19 5 19H19C19.5523 19 20 18.5523 20 18V16C20 15.4477 19.5523 15 19 15ZM7 16C7.55228 16 8 16.4477 8 17C8 17.5523 7.55228 18 7 18C6.44772 18 6 17.5523 6 17C6 16.4477 6.44772 16 7 16ZM16 11H8V13H16V11ZM19 5H5C4.44772 5 4 5.44772 4 6V8C4 8.55228 4.44772 9 5 9H19C19.5523 9 20 8.55228 20 8V6C20 5.44772 19.5523 5 19 5ZM7 6C7.55228 6 8 6.44772 8 7C8 7.55228 7.55228 8 7 8C6.44772 8 6 7.55228 6 7C6 6.44772 6.44772 6 7 6Z"
    fill="currentColor"
  />
</svg>
